module.exports = __webpack_public_path__ + "img/smart_description.f159b1bc.png";